import { render, staticRenderFns } from "./changePatient.vue?vue&type=template&id=5a97dcfc&scoped=true&"
import script from "./changePatient.vue?vue&type=script&lang=js&"
export * from "./changePatient.vue?vue&type=script&lang=js&"
import style0 from "./changePatient.vue?vue&type=style&index=0&id=5a97dcfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97dcfc",
  null
  
)

export default component.exports